import styled from 'styled-components';
import DocumentsFormQuestion from './DocumentsFormQuestion';
import { colorSchema, media } from 'utils/style';

export default styled(DocumentsFormQuestion)`
  &.documents-form-question {
    display: flex;
    flex-direction: column;
    margin: 1.2rem 0;

    label,
    legend {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: 500;
      margin-bottom: 0.8rem;
      text-transform: none;
    }

    input {
      height: 48px;
      &[type='radio'] {
        height: auto;
      }
    }

    & > div {
      width: 100%;
    }

    &--error {
      input {
        border: 1px solid ${colorSchema('error700')};
        &:focus {
          box-shadow: none;
          outline: none;
        }
      }
    }

    &--radio {
      label {
        font-weight: normal;
      }
    }

    &--disabled {
      input {
        border: 0;
        padding: 0;
      }
    }

    &--is_autonomous {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 12;
        `}
    }

    &--name {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 4;
        `}
    }

    &--tax_number {
      ${media.greaterThan('tablet')`
          grid-column: 5 / span 3;
        `}
    }

    &--contact_name {
      ${media.greaterThan('tablet')`
          grid-column: 8 / span 4;
        `}
    }

    &--zipcode {
      ${media.greaterThan('tablet')`
          grid-column: 5 / span 2;
        `}
    }

    &--city {
      ${media.greaterThan('tablet')`
          grid-column: 7 / span 4;
        `}
    }

    &--address_line {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 8;
        `}
    }

    &--iban {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 4;
        `}
    }

    &--billing_email {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 4;
        `}
    }

    &--fiscal-payment {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 4;
        `}
    }

    &--extra-questions {
      ${media.greaterThan('tablet')`
          grid-column: 1 / span 3;
        `}
    }
  }
`;
